'use strict';

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageChannel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _methodChooser = require('./methodChooser');

var _utils = require('../utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MessageChannel = exports.MessageChannel = function () {
  function MessageChannel(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, MessageChannel);

    this.name = name;
    this.options = options;
    this.method = (0, _methodChooser.chooseMethod)(this.options);
    this.closed = false;

    // isListening
    this._isListening = false;

    /**
     * _onMessageListener
     * setting onmessage twice,
     * will overwrite the first listener
     */
    this._onMessageListener = null;

    /**
     * _addEventListeners
     */
    this._addEventListeners = {
      message: [],
      internal: []

      /**
       * Un send message promises
       * where the sending is still in progress
       * @type {Set<Promise>}
       */
    };this._unSendMessagePromises = new _set2.default();

    /**
     * _beforeClose
     * array of promises that will be awaited
     * before the channel is closed
     */
    this._beforeClose = [];

    /**
     * _preparePromise
     */
    this._preparePromises = null;
    _prepareChannel(this);
  }

  _createClass(MessageChannel, [{
    key: 'postMessage',
    value: function postMessage(msg) {
      if (this.closed) {
        throw new Error('❌ Cannot post message after channel has closed');
      }
      return _post(this, 'message', msg);
    }
  }, {
    key: 'postInternal',
    value: function postInternal(msg) {
      return _post(this, 'internal', msg);
    }
  }, {
    key: 'addEventListener',
    value: function addEventListener(type, fn) {
      var time = this.method.microSeconds();
      var listenObj = {
        time: time,
        fn: fn
      };
      _addListenerObject(this, type, listenObj);
    }
  }, {
    key: 'removeEventListener',
    value: function removeEventListener(type, fn) {
      var obj = this._addEventListeners[type].find(function (obj) {
        return obj.fn === fn;
      });
      _removeListenerObject(this, type, obj);
    }
  }, {
    key: 'close',
    value: function close() {
      var _this = this;

      if (this.closed) {
        return;
      }
      this.closed = true;
      var awaitPrepare = this._preparePromises ? this._preparePromises : _promise2.default.resolve();

      this._onMessageListener = null;
      this._addEventListeners.message = [];

      return awaitPrepare
      // Wait until all current sending are processed
      .then(function () {
        return _promise2.default.all((0, _from2.default)(_this._unSendMessagePromises));
      })
      // Run before-close hooks
      .then(function () {
        return _promise2.default.all(_this._beforeClose.map(function (fn) {
          return fn();
        }));
      })
      // Close the channel
      .then(function () {
        return _this.method.close(_this._state);
      });
    }
  }, {
    key: 'isClosed',
    value: function isClosed() {
      return this.closed;
    }
  }, {
    key: 'onmessage',
    set: function set(fn) {
      var time = this.method.microSeconds();
      var listenObj = {
        time: time,
        fn: fn
      };
      _removeListenerObject(this, 'message', this._onMessageListener);
      if (fn && typeof fn === 'function') {
        this._onMessageListener = listenObj;
        _addListenerObject(this, 'message', listenObj);
      } else {
        /* istanbul ignore next */
        this._onMessageListener = null;
      }
    }

    /* istanbul ignore next */
    ,
    get: function get() {
      return this._onMessageListener;
    }
  }, {
    key: 'type',
    get: function get() {
      return this.method.type;
    }
  }]);

  return MessageChannel;
}();

function _post(messageChannel, type, msg) {
  var time = messageChannel.method.microSeconds();
  var msgObj = {
    time: time,
    type: type,
    data: msg
  };

  var awaitPrepare = messageChannel._preparePromises ? messageChannel._preparePromises : _promise2.default.resolve();
  return awaitPrepare.then(function () {
    var sendPromise = messageChannel.method.postMessage(messageChannel._state, msgObj);

    // add/remove to un-send messages list
    messageChannel._unSendMessagePromises.add(sendPromise);
    sendPromise.catch().then(function () {
      return messageChannel._unSendMessagePromises.delete(sendPromise);
    });

    return sendPromise;
  });
}

function _prepareChannel(channel) {
  var maybePromise = channel.method.create(channel.name, channel.options);
  /* istanbul ignore next */
  if ((0, _utils.isPromise)(maybePromise)) {
    channel._preparePromises = maybePromise;
    maybePromise.then(function (s) {
      channel._state = s;
    });
  } else {
    channel._state = maybePromise;
  }
}

function _hasMessageListeners(channel) {
  if (channel._addEventListeners.message.length > 0) return true;
  if (channel._addEventListeners.internal.length > 0) return true;
  return false;
}

function _addListenerObject(channel, type, obj) {
  channel._addEventListeners[type].push(obj);
  _startListening(channel);
}

function _removeListenerObject(channel, type, obj) {
  channel._addEventListeners[type] = channel._addEventListeners[type].filter(function (o) {
    return o !== obj;
  });
  _stopListening(channel);
}

function _startListening(channel) {
  if (!channel._isListening && _hasMessageListeners(channel)) {
    // someone is listening, start subscribing

    var listenerFn = function listenerFn(msgObj) {
      channel._addEventListeners[msgObj.type].forEach(function (obj) {
        if (msgObj.time >= obj.time) {
          obj.fn(msgObj.data);
        }
      });
    };

    var time = channel.method.microSeconds();
    if (channel._preparePromises) {
      /* istanbul ignore next */
      channel._preparePromises.then(function () {
        channel._isListening = true;
        channel.method.onMessage(channel._state, listenerFn, time);
      });
    } else {
      channel._isListening = true;
      channel.method.onMessage(channel._state, listenerFn, time);
    }
  }
}

function _stopListening(channel) {
  if (channel._isListening && !_hasMessageListeners(channel)) {
    // no one is listening, stop subscribing
    channel._isListening = false;
    var time = channel.method.microSeconds();
    channel.method.onMessage(channel._state, null, time);
  }
}